import React from 'react';
interface KPIGaugeProps {
  label: string;
  percentage: number;
  value: string;
  color?: string;
}
export function KPIGauge({
  label,
  percentage,
  value,
  color = '#2563eb'
}: KPIGaugeProps) {
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - percentage / 100 * circumference;
  return <div className="flex flex-col items-center" data-id="element-273">
      <div className="relative w-48 h-48" data-id="element-274">
        <svg className="transform -rotate-90 w-full h-full" data-id="element-275">
          {/* Background circle */}
          <circle cx="96" cy="96" r={radius} stroke="#e5e7eb" strokeWidth="16" fill="none" data-id="element-276" />
          {/* Progress circle */}
          <circle cx="96" cy="96" r={radius} stroke={color} strokeWidth="16" fill="none" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" className="transition-all duration-1000 ease-out" data-id="element-277" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-278">
          <div className="text-3xl font-bold text-gray-900" data-id="element-279">{percentage}%</div>
          <div className="text-sm text-green-600 bg-green-50 px-2 py-0.5 rounded mt-1" data-id="element-280">
            {value}
          </div>
        </div>
      </div>
      <div className="text-sm text-gray-600 mt-3 text-center font-medium" data-id="element-281">
        {label}
      </div>
    </div>;
}